// Pure formatter for resolution numbers — backend stores resolution as the
// long-side pixel count (e.g. 1024 / 2048 / 4096) and the UI shows it as a
// short label (e.g. `1024p`, `2K`, `4K`). Always store the int, format only
// when rendering.
//
// Exception: Seedance's 4K UHD tier is stored as its 2160 short-side value
// (matching the backend `2160 → "4k"` mapping), not the 4096 long-side value,
// so it needs an explicit case — the generic `Math.round(px / 1000)` would
// render it as `2K`.
export function resolutionLabel(px: number): string {
    if (px === 2160) return "4K";
    if (px >= 2000) return `${Math.round(px / 1000)}K`;
    return `${px}p`;
}
